import {
  checkIsMastraErrorToolOutput,
  type MastraErrorToolOutput,
} from "@repo/app-types/agents/mastraErrorToolOutput";
import {
  checkIsNoResultToolOutput,
  type NoResultToolOutput,
} from "@repo/app-types/agents/noResultToolOutput";
import type {
  GetSampleCriteriaScoreDistributionAndOutcomeCorrelationToolInput,
  GetSampleCriteriaScoreDistributionAndOutcomeCorrelationToolOutput,
} from "@repo/app-types/entities/configurationAgent";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

export const GetSampleCriteriaScoreDistributionAndOutcomeCorrelationTool: ToolComponent<
  GetSampleCriteriaScoreDistributionAndOutcomeCorrelationToolInput,
  | GetSampleCriteriaScoreDistributionAndOutcomeCorrelationToolOutput
  | MastraErrorToolOutput
  | NoResultToolOutput
> = (props) => {
  if (props.status.type === "running") {
    return (
      <ChatToolBase status={props.status}>
        Getting sample criterion metrics
      </ChatToolBase>
    );
  }

  // An expected condition (no outcome configured, criterion not found, no
  // samples in the window, ...) — surface the feedback as a completed, not
  // failed, tool call.
  if (checkIsNoResultToolOutput(props.output)) {
    return (
      <ChatToolBase status={props.status}>{props.output.message}</ChatToolBase>
    );
  }

  if (checkIsMastraErrorToolOutput(props.output)) {
    return (
      <ChatToolBase status={props.status}>
        An error occurred while getting sample criterion metrics
      </ChatToolBase>
    );
  }

  if (props.status.type === "complete" && props.output) {
    if (typeof props.output.sample_size !== "number") {
      return (
        <ChatToolBase status={props.status}>
          No sample interactions available for this criterion
        </ChatToolBase>
      );
    }
    return (
      <ChatToolBase status={props.status}>
        Analyzed criterion on {props.output.sample_size.toLocaleString()}{" "}
        interactions
      </ChatToolBase>
    );
  }

  return (
    <ChatToolBase status={props.status}>
      Getting sample criterion metrics...
    </ChatToolBase>
  );
};
